<template>
  <div>
    <b-card>

      <div class="d-flex justify-content-between mb-3">
        <h3>Subscription Plans</h3>
        <b-button variant="primary" @click="openCreate">
          Create Plan
        </b-button>
      </div>

      <b-table :items="plans" :fields="fields" small responsive>
        <template #cell(price)="row">
          ${{ row.item.price }}
        </template>

        <template #cell(manage)="row">
          <b-button size="sm" variant="info" @click="editPlan(row.item)">
            Edit
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="totalItems"
        :per-page="perPage"
        align="right"
      />

    </b-card>

    <CreateSubscriptionPlanModal
      @modalClosed="fetchPlans"
      :key="createKey"
    />

    <EditSubscriptionPlanModal
      :plan="plan"
      @modalClosed="fetchPlans"
      :key="editKey"
    />

  </div>
</template>

<script>
import { mapActions } from "vuex";
import CreateSubscriptionPlanModal from "@/components/subscription_plan/CreateSubscriptionPlanModal.vue";
import EditSubscriptionPlanModal from "@/components/subscription_plan/EditSubscriptionPlanModal.vue";

export default {
  components: {
    CreateSubscriptionPlanModal,
    EditSubscriptionPlanModal,
  },

  data() {
    return {
      fields: [
        { key: "name", label: "Plan Name" },
        { key: "price", label: "Price" },
        { key: "lead_limit", label: "Lead Limit" },
        { key: "manage", label: "Manage" },
      ],
      plans: [],
      currentPage: 1,
      totalItems: 0,
      perPage: 0,
      plan: null,
      createKey: 0,
      editKey: 0,
    };
  },

  mounted() {
    this.fetchPlans();
  },

  methods: {
    ...mapActions("appData", [
      "getSubscriptionPlans",
    ]),

    async fetchPlans() {
      const res = await this.getSubscriptionPlans({
        page: this.currentPage,
      });
      this.plans = res.data.results;
      this.totalItems = res.data.count;
      this.perPage = res.data.per_page;
    },

    openCreate() {
      this.createKey++;
      this.$nextTick(() =>
        this.$bvModal.show("create-subscription-plan-modal")
      );
    },

    editPlan(plan) {
      this.plan = plan;
      this.editKey++;
      this.$nextTick(() =>
        this.$bvModal.show("edit-subscription-plan-modal")
      );
    },
  },

  watch: {
    currentPage() {
      this.fetchPlans();
    },
  },
};
</script>